module.exports = __webpack_public_path__ + "img/story044.dbcff64f.webp";